import { BaseApi } from "./apiHandler";
import { axiosInstance, axiosPrivate, axiosPrivateBlob } from "./axios";
import { BlobApi } from "./BlobAxios";
// Side-effect import — ensures HTTP logger interceptors are attached to all
// axios instances before any request fires.
import "./privateAxios";

export const api = new BaseApi(axiosInstance);
export const privateApi = new BaseApi(axiosPrivate);
export const privateBlobApi = new BlobApi(axiosPrivateBlob);
